export default __webpack_public_path__ + "static/968-2aa5859a71916e6278c79eee5ef0dc11.gif";